
import { useRef } from "react";
// --- swiper ----------------------------------------------------------------
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
// --- lottie ----------------------------------------------------------------
import Lottie from "lottie-react";
import contactLogo from "../../assets/lotties/logo-purple.json";
// --- img ----------------------------------------------------------------
import { 
  kakaoIcon,
  serviceLoungeImg,
  serviceLoungeSlide01,
  serviceLoungeSlide02,
  serviceLoungeSlide03,
  arrowIconPrev,
  arrowIconNext,
 } from "../../assets/images";
 // --- style ----------------------------------------------------------------
 import "./Service.scss";

function ExperienceLounge() {
  // --- 이미지 데이터 ----------------------------------------------------------------
  const spaceImages = [serviceLoungeSlide01, serviceLoungeSlide02, serviceLoungeSlide03];
  const privateImages = [serviceLoungeSlide01, serviceLoungeSlide02, serviceLoungeSlide03];
  const photozoneImages = [serviceLoungeSlide01, serviceLoungeSlide02, serviceLoungeSlide03];

  // --- 컨트롤러 ----------------------------------------------------------------
  const spacePrevRef = useRef(null);
  const spaceNextRef = useRef(null);

  const studioPrevRef = useRef(null);
  const studioNextRef = useRef(null);

  const photoPrevRef = useRef(null);
  const photoNextRef = useRef(null);  

  const bindNav = (swiper, prevRef, nextRef) => {
    if (!swiper) return;

    // 버튼 ref가 아직이면 다음 프레임에 다시 시도
    requestAnimationFrame(() => {
      const prevEl = prevRef.current;
      const nextEl = nextRef.current;
      if (!prevEl || !nextEl) return;

      swiper.params.navigation.prevEl = prevEl;
      swiper.params.navigation.nextEl = nextEl;

      swiper.navigation.destroy();
      swiper.navigation.init();
      swiper.navigation.update();
    });
  };  

  return (
    <div className="content-section lounge">
      {/* === BANNER === */}
      <div className="lounge__banner max-12">
        <dl>
          <dt>“하루의 영감이 시작되는 곳”</dt>
          <dd>
            커피 한 잔과 함께, 당신의 음악이 태어납니다<br />
            MOB 체험 카페는 음악, 창작, 휴식이 공존하는 <span className="spacing">문화공간입니다</span>
          </dd>
        </dl>
        <div className="floating-desc">
          <ul>
            <li>
              <p>원하는 키워드,감정,장르로</p>
              <strong>AI 작곡 체험</strong>
            </li>
            <li>
              <p>생성된 음악 즉시 무료 다운로드</p>
              <strong>MP3 파일 소장</strong>
            </li>
            <li>
              <p>1인 10,000원 (1시간)</p>
              <strong>예약 필수</strong>
            </li>
          </ul>
          <img src={serviceLoungeImg} alt="" aria-hidden="true" />
        </div>
      </div>

      {/* === SPACE INTRODUCTION === */}
      <div className="lounge__slider max-12">
        <div className="content-section__title">
          <span>창작과 경험이 함께하는 복합 문화 공간</span>
          <h3 className="gfont">SPACE INTRODUCTION</h3>
        </div>

        <div className="image-slider">
          {/* 이미지 슬라이더 영역 */}
          <Swiper
            modules={[Autoplay, Navigation]}
            loop
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            slidesPerView="auto"
            navigation
            onSwiper={(swiper) => bindNav(swiper, spacePrevRef, spaceNextRef)}                           
            className="hero-swiper"
            centeredSlides
          >
            {spaceImages.map((img, i) => (
              <SwiperSlide key={i} className="hero-slide">
                <img src={img} alt="" />
              </SwiperSlide>
            ))}
          </Swiper>  

          {/* 커스텀 컨트롤러 */}
          <button ref={spacePrevRef} className="hero-controller hero-prev">
            <img src={arrowIconPrev} alt="prev" />
          </button>
          <button ref={spaceNextRef} className="hero-controller hero-next">
            <img src={arrowIconNext} alt="next" />
          </button>       
        </div>    
      </div>

      {/* === PRIVATE STUDIO === */}
      <div className="lounge__slider max-12">
        <div className="content-section__title">
          <span>음악, 보컬, 콘텐츠 연습을 위한 프라이빗 공간</span>
          <h3 className="gfont">PRIVATE STUDIO</h3>
        </div>

        <div className="image-slider">
          {/* 이미지 슬라이더 영역 */}
          <Swiper
            modules={[Autoplay, Navigation]}
            loop
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            slidesPerView="auto"
            navigation
            onSwiper={(swiper) => bindNav(swiper, studioPrevRef, studioNextRef)}                         
            centeredSlides
            className="hero-swiper"
          >
            {privateImages.map((img, i) => (
              <SwiperSlide key={i} className="hero-slide">
                <img src={img} alt="" />
              </SwiperSlide>
            ))}
          </Swiper>  

          {/* 커스텀 컨트롤러 */}
          <button ref={studioPrevRef} className="hero-controller hero-prev">
            <img src={arrowIconPrev} alt="prev" />
          </button>
          <button ref={studioNextRef} className="hero-controller hero-next">
            <img src={arrowIconNext} alt="next" />
          </button>            
        </div>           
      </div>

      {/* === PHOTO ZONE === */}
      <div className="lounge__slider max-12">
        <div className="content-section__title">
          <span>이곳에서 모든 장면이 한 장의 사진이 됩니다</span>
          <h3 className="gfont">PHOTO ZONE</h3>
        </div>

        <div className="image-slider">
          {/* 이미지 슬라이더 영역 */}
          <Swiper
            modules={[Autoplay, Navigation]}
            loop
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            slidesPerView="auto"
            navigation
            onSwiper={(swiper) => bindNav(swiper, photoPrevRef, photoNextRef)}                            
            centeredSlides
            className="hero-swiper"
          >
            {photozoneImages.map((img, i) => (
              <SwiperSlide key={i} className="hero-slide">
                <img src={img} alt="" />
              </SwiperSlide>
            ))}
          </Swiper>

          {/* 커스텀 컨트롤러 */}
          <button ref={photoPrevRef} className="hero-controller hero-prev">
            <img src={arrowIconPrev} alt="prev" />
          </button>
          <button ref={photoNextRef} className="hero-controller hero-next">
            <img src={arrowIconNext} alt="next" />
          </button>           
        </div>    
      </div>            


      {/* === INQUIRY === */} 
      <div className="content-section__contact">
        <p className="desc">
          ALL MAKERS, ONE STAGE. 지금 당신의 무대를 시작하세요
        </p>
        <h3 className="gfont title">
          RESERVATION INQUIRY
        </h3>
        <Lottie
          animationData={contactLogo}
          loop
          autoplay
          className="contact-lottie"
        />

        <div className="kakao-link">
          <span>지금 시작해 보세요.</span>
          <a 
          href="https://pf.kakao.com/_QLTxgn"
          target="_blank"
          rel="noopener noreferrer"
          >
            <img src={kakaoIcon} alt="" aria-hidden="true" />
            카카오 채널 문의
          </a>
        </div>
      </div>       
    </div>
  )
}

export default ExperienceLounge